import React from 'react';
import styled from 'styled-components';
import Spinner from '../../../images/spinner.gif';

const Container = styled.div`
    width: 100%;
    height: max-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 1.5rem;
    gap: 8px;

    @media screen and (max-width: 560px) {
        gap: 4px;
    }
`;

const Image = styled.img`
    height: 65px;
    width: 65px;

    @media screen and (max-width: 500px) {
        height: 40px;
        width: 40px;
    }
`;

const Text = styled.p`
    font-size: 16px;
    font-weight: 400;
    color: #252963;

    @media screen and (max-width: 500px) {
        font-size: 14px;
    }
`;

const Loader = () => {
    return (
        <Container>
            <Image src={Spinner} alt="loader" />
            <Text>Loading...</Text>
        </Container>
    );
};

export default Loader;
